import React from "react";
import { cn } from "./ui/utils";
import { STEPS, stageStep } from "./stageSteps";

// Six small segments: done steps in the primary colour, the current one
// stronger; a returned or cancelled request is shown as a muted, stopped bar.
const StageProgress = ({ stage, className, wide = false }) => {
  const { index, stopped } = stageStep(stage);
  const label = stopped
    ? "Stopped before delivery"
    : index >= 0
      ? `Step ${index + 1} of ${STEPS.length}: ${STEPS[index]}`
      : "Stage unknown";
  return (
    <div
      role="img"
      aria-label={label}
      title={label}
      data-stopped={stopped || undefined}
      className={cn("tw-flex tw-items-center tw-gap-0.5", className)}
    >
      {STEPS.map((step, position) => {
        const done = !stopped && position <= index;
        return (
          <span
            key={step}
            className={cn(
              "tw-h-1.5 tw-rounded-full",
              wide ? "tw-flex-1" : "tw-w-3.5",
              stopped
                ? "tw-bg-slate-300"
                : done
                  ? position === index
                    ? index === STEPS.length - 1
                      ? "tw-bg-emerald-500"
                      : "tw-bg-primary"
                    : "tw-bg-primary/50"
                  : "tw-bg-slate-200",
            )}
          />
        );
      })}
    </div>
  );
};

// The step names under a wide progress bar (used in the order panel header).
export const StageSteps = ({ stage }) => {
  const { index, stopped } = stageStep(stage);
  return (
    <ol className="tw-m-0 tw-mt-1.5 tw-grid tw-list-none tw-grid-cols-6 tw-gap-0.5 tw-p-0">
      {STEPS.map((step, position) => (
        <li
          key={step}
          className={cn(
            "tw-truncate tw-text-[11px] tw-leading-4",
            !stopped && position <= index ? "tw-font-medium tw-text-foreground" : "tw-text-muted-foreground",
          )}
        >
          {step}
        </li>
      ))}
    </ol>
  );
};

export default StageProgress;
